const TypingIndicator = ({ label = 'Owen is typing' }) => (
  <div className="lk-conv-msg lk-conv-msg--assistant lk-conv-typing" aria-label={label}>
    <span className="lk-conv-typing__dot" />
    <span className="lk-conv-typing__dot" />
    <span className="lk-conv-typing__dot" />
  </div>
);

export default TypingIndicator;
